<script lang="ts">
  import Footer from './components/Footer/Footer.svelte'
  import RecruitArea from './components/RecruitArea/RecruitArea.svelte'
  import Header from './components/Header/Header.svelte'
  import MainVisual from './components/MainVisual/MainVisual.svelte'
  import CompanyArea from './components/svelte/CompanyArea.svelte'
  import ServiceArea from './components/svelte/ServiceArea.svelte'
  import News from './components/News/News.svelte'
  import './scss/index.scss'

  // Initialize Google Analytics
  const GA_TRACKING_ID = 'UA-136270102-4'
  
  import { onMount } from 'svelte'
  onMount(() => {
    // Initialize GA
    if (typeof window !== 'undefined') {
      // @ts-ignore
      window.dataLayer = window.dataLayer || []
      function gtag(...args: any[]) {
        // @ts-ignore
        window.dataLayer.push(args)
      }
      gtag('js', new Date())
      gtag('config', GA_TRACKING_ID)
    }
  })
</script>

<svelte:head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0"
  />
  <meta name="format-detection" content="telephone=no" />
  <meta name="rating" content="general" />
  <meta name="author" content="SPTR" />
  <meta
    name="copyright"
    content="(C)Spartan English training academy, Inc."
  />
  <meta
    name="google-site-verification"
    content="Rck1dbPDNOcYhmH3Gk0Cq_roLYFtCG0I1IZWEGvNh3Y"
  />

  <meta
    name="description"
    content="日常英会話からビジネス英語まで幅広く対応、オンライン英会話の「スパトレ」を運営するスパトレ株式会社のコーポレートサイトです。"
  />
  <meta name="keywords" content="" />

  <!-- OGP -->
  <meta property="og:site_name" content="SPTR［スパトレ］" />
  <meta property="og:title" content="スパトレ株式会社" />
  <meta
    property="og:description"
    content="日常英会話からビジネス英語まで幅広く対応、オンライン英会話の「スパトレ」を運営するスパトレ株式会社のコーポレートサイトです。"
  />
  <meta
    property="og:image"
    content="https://corporate.sptr.jp/img/ogp.png"
  />
  <meta property="og:url" content="https://corporate.sptr.jp/" />
  <meta property="og:type" content="website" />

  <!-- TwitterCardOGP -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="スパトレ株式会社" />
  <meta
    name="twitter:description"
    content="日常英会話からビジネス英語まで幅広く対応、オンライン英会話の「スパトレ」を運営するスパトレ株式会社のコーポレートサイトです。"
  />

  <title>スパトレ株式会社</title>
  <link rel="shortcut icon" href="img/favicon.png" />
  <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}></script>
</svelte:head>

<div class="container">
  <Header />
  <MainVisual />
  <ServiceArea />
  <News />
  <CompanyArea />
  <RecruitArea />
  <Footer />
</div>

<style>
  :global(*) {
    box-sizing: border-box;
  }
  
  :global(body) {
    margin: 0;
    font-family: 'Noto Sans JP';
    background-color: var(--color-background);
    display: flex;
    flex-flow: column;
    min-height: 100vh;
  }

  .container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
</style>
